import { Tooltip } from 'antd';
import { useState } from 'react';

interface IdTableCellProps {
    value?: any;
}

export const IdTableCell = ({ value }: IdTableCellProps) => {
    const [copied, setCopied] = useState(false);

    const shortenUUID = (uuid: string, start = 3, end = 3) => {
        if (!uuid) {
            return '';
        }

        if (uuid.length <= start + end) {
            return uuid;
        }

        return `${uuid.slice(0, start)}...${uuid.slice(-end)}`;
    };

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(value);
            setCopied(true);
            setTimeout(() => setCopied(false), 1500); // сброс через 1.5 сек
        } catch (err) {
            console.error('Ошибка копирования UUID:', err);
        }
    };

    return (
        <Tooltip title={copied ? 'Copied!' : value}>
            <span onClick={handleCopy} style={{ cursor: 'pointer' }}>{shortenUUID(value)}</span>
        </Tooltip>
    );
};
